import React from 'react'
import { IPageDesginerDataType, useConfig } from 'msp-integrations'
import { transformRegionToMap } from '@utils/pageUtils'
import DynamicTag from '@molecules/DynamicTag/DynamicTag'
import CustomLinkComponent from '@atoms/CustomLink/CustomLinkComponent'
import BaseRichTextComponent from '@cms/RichText/BaseRichTextComponent'
import Button from '@atoms/Button/Button'
import * as S from './SlideItem.styles'

export function buildTopRegion(
  [slideTopRegion]: IPageDesginerDataType[],
  sliderStyle: string,
  font: string,
  ignoreWrapperStyle = false
) {
  const headlineSublineRegions = transformRegionToMap(
    slideTopRegion?.regions || []
  )
  const prelineClasses = ['flex pb-4 ', S.SliderTextStyle[sliderStyle]]
  const isLightStyle = sliderStyle === 'light'
  const prelineRegion = headlineSublineRegions?.get('prelineRegion')
  const headlineRegion = headlineSublineRegions?.get('headlineRegion')
  const [prelineComponent] = prelineRegion?.components || null
  const [headlineComponent] = headlineRegion?.components || null

  return (
    <div className={!ignoreWrapperStyle ? S.SlideTextContentWrapper : ''}>
      <DynamicTag
        {...prelineComponent?.data}
        className={prelineClasses.join(' ')}
        componentTagName='Preline'
      />
      <DynamicTag
        {...headlineComponent?.data}
        className={`${font} ${S.SlideTopRegionRichText} ${
          isLightStyle ? 'text-black' : 'text-white'
        }`}
        componentTagName='Headline'
      />
    </div>
  )
}

function buildImageRegion(
  [slideImageRegion]: IPageDesginerDataType[],
  isFullImage: boolean
) {
  const { data, custom } = slideImageRegion
  const imageClasses = [S.SlideImageWrapper, isFullImage ? 'lg:h-full' : '']

  return (
    <div className={imageClasses.join(' ')}>
      <img
        src={custom?.content?.image?.path}
        alt={data?.imageAlt}
        className={S.SlideImage}
      />
    </div>
  )
}

function buildBottomRegion(
  [headline, textContent]: IPageDesginerDataType[],
  sliderStyle: string,
  font: string
) {
  const isLightStyle = sliderStyle === 'light'
  const headlineClasses = [
    'pb-4 ',
    'headline-h5',
    S.SliderTextStyle[sliderStyle]
  ]
  const richTextData = {
    ...textContent?.data,
    textColor: !isLightStyle ? 'white' : null,
    hasCustomStyle: true
  }

  return (
    <>
      {headline?.data && (
        <DynamicTag
          className={headlineClasses.join(' ')}
          componentTagName='Headline'
          {...headline?.data}
          tag='h2'
        ></DynamicTag>
      )}
      <BaseRichTextComponent
        className={`${font} ${S.SlideBottomRegionRichText}`}
        data={richTextData}
      />
    </>
  )
}

const SlideItem = ({ data, regions }: IPageDesginerDataType) => {
  const areas = transformRegionToMap(regions)
  const { isFullImage, sliderStyle } = data
  const {
    theme: {
      font: { fontVariant: font }
    }
  } = useConfig()
  const slideTopRegion = areas?.get('slideTopRegion')?.components || null
  const slideImageRegion = areas?.get('slideImageRegion')?.components || []
  const slideBottomRegion = areas?.get('slideBottomRegion')?.components || []
  const isLightStyle = sliderStyle === 'light'
  const slideCTAComponent = slideBottomRegion.slice(-1)[0]

  return (
    <>
      <div className={S.SlideTileWrapper}>
        <div className={S.SlideHeadWrapper}>
          {!isFullImage &&
            slideTopRegion &&
            buildTopRegion(slideTopRegion, sliderStyle as string, font)}
          {slideImageRegion &&
            buildImageRegion(slideImageRegion, isFullImage as boolean)}
        </div>
        <div
          className={
            isLightStyle ? S.SlideContentWrapper : S.SlideContentDarkWrapper
          }
        >
          {slideBottomRegion &&
            buildBottomRegion(slideBottomRegion, sliderStyle as string, font)}
        </div>
        {isLightStyle && slideCTAComponent?.type_id === 'pwa.customLink' && (
          <div className='flex pt-4 sm:pt-0'>
            <CustomLinkComponent
              custom={slideCTAComponent.custom}
              inline={true}
            >
              <Button
                variant={'outline'}
                type={'secondary'}
                className={S.SlideCTAButton}
              >
                {slideCTAComponent.data?.textContent || 'NO TEXT'}
              </Button>
            </CustomLinkComponent>
          </div>
        )}
      </div>
    </>
  )
}

export default SlideItem
